import { usePeopleAPI } from "@certn/legacy-api";

export function useLanguageOptions() {
  const { data: languageOptions, isLoading } = usePeopleAPI(
    "/internal/people/language-options/"
  );

  return {
    languageOptions,
    isLoading,
  };
}
